module.exports = {
  "!mb3c!l3": 1,
  "!mbec!l3": 1,
  "!mbéc!l3": 1,
  "!mbec!le": 1,
  "!mbéc!le": 1,
  "@brut!": 1,
  "@brut1": 1,
  "@bruti": 1,
  "@nd0u!ll3": 1,
  "@nd0u!lle": 1,
  "@nd0u1ll3": 1,
  "@nd0u1lle": 1,
  "@nd0uill3": 1,
  "@nd0uille": 1,
  "@ndou!ll3": 1,
  "@ndou!lle": 1,
  "@ndou1ll3": 1,
  "@ndou1lle": 1,
  "@ndouill3": 1,
  "@ndouille": 1,
  "@v0rt0n": 1,
  "@vorton": 1,
  "1mb3c1l3": 1,
  "1mbec1l3": 1,
  "1mbéc1l3": 1,
  "1mbec1le": 1,
  "1mbéc1le": 1,
  "35p!ng0!n": 1,
  "35p!ngo!n": 1,
  "35p1ng01n": 1,
  "35p1ngo1n": 1,
  "35ping0in": 1,
  "35pingoin": 1,
  "3mm@nch3": 1,
  "3mm@nche": 1,
  "3mm@nché": 1,
  "3mm3rd3r": 1,
  "3mm3rd3u53": 1,
  "3mm3rd3ur": 1,
  "3mm3rd3us3": 1,
  "3mmanch3": 1,
  "3mmanche": 1,
  "3mmanché": 1,
  "3mp@f3": 1,
  "3mp@fe": 1,
  "3mp@fé": 1,
  "3mp@p@0ut3": 1,
  "3mp@p@0ute": 1,
  "3mp@p@0uté": 1,
  "3mp@p@out3": 1,
  "3mp@p@oute": 1,
  "3mp@p@outé": 1,
  "3mpaf3": 1,
  "3mpafe": 1,
  "3mpafé": 1,
  "3mpapa0ut3": 1,
  "3mpapa0ute": 1,
  "3mpapa0uté": 1,
  "3mpapaout3": 1,
  "3mpapaoute": 1,
  "3mpapaouté": 1,
  "3ncul3": 1,
  "3ncul3r": 1,
  "3ncul3ur": 1,
  "3ncule": 1,
  "3nculé": 1,
  "3nf0!r3": 1,
  "3nf0!re": 1,
  "3nf0!ré": 1,
  "3nf01r3": 1,
  "3nf01re": 1,
  "3nf01ré": 1,
  "3nf0ir3": 1,
  "3nf0ire": 1,
  "3nf0iré": 1,
  "3nflur3": 1,
  "3nfo!r3": 1,
  "3nfo!re": 1,
  "3nfo!ré": 1,
  "3nfo1r3": 1,
  "3nfo1re": 1,
  "3nfo1ré": 1,
  "3nfoir3": 1,
  "3nfoire": 1,
  "3nfoiré": 1,
  "3nv@53l!n3ur": 1,
  "3nv@53l1n3ur": 1,
  "3nv@53lin3ur": 1,
  "3nv@s3l!n3ur": 1,
  "3nv@s3l1n3ur": 1,
  "3nv@s3lin3ur": 1,
  "3nva53l!n3ur": 1,
  "3nva53l1n3ur": 1,
  "3nva53lin3ur": 1,
  "3nvas3l!n3ur": 1,
  "3nvas3l1n3ur": 1,
  "3nvas3lin3ur": 1,
  "3p@!5": 1,
  "3p@!s": 1,
  "3p@15": 1,
  "3p@1s": 1,
  "3p@i5": 1,
  "3p@is": 1,
  "3pa!5": 1,
  "3pa!s": 1,
  "3pa15": 1,
  "3pa1s": 1,
  "3pai5": 1,
  "3pais": 1,
  "3sp!ng0!n": 1,
  "3sp!ngo!n": 1,
  "3sp1ng01n": 1,
  "3sp1ngo1n": 1,
  "3sping0in": 1,
  "3spingoin": 1,
  "3tr0n": 1,
  "3tron": 1,
  "5@g0u!n": 1,
  "5@g0u1n": 1,
  "5@g0uin": 1,
  "5@gou!n": 1,
  "5@gou1n": 1,
  "5@gouin": 1,
  "5@l@ud": 1,
  "5@l0p": 1,
  "5@l0p@rd": 1,
  "5@l0p3": 1,
  "5@l0pe": 1,
  "5@l3": 1,
  "5@le": 1,
  "5@lop": 1,
  "5@lop@rd": 1,
  "5@lop3": 1,
  "5@lope": 1,
  "5@tr0u!ll3": 1,
  "5@tr0u!lle": 1,
  "5@tr0u1ll3": 1,
  "5@tr0u1lle": 1,
  "5@tr0uill3": 1,
  "5@tr0uille": 1,
  "5@trou!ll3": 1,
  "5@trou!lle": 1,
  "5@trou1ll3": 1,
  "5@trou1lle": 1,
  "5@trouill3": 1,
  "5@trouille": 1,
  "50tt!53ux": 1,
  "50tt!5eux": 1,
  "50tt153ux": 1,
  "50tt15eux": 1,
  "50tti53ux": 1,
  "50tti5eux": 1,
  "50u5-m3rd3": 1,
  "50u5-merde": 1,
  "53nt-l@-p!553": 1,
  "53nt-l@-p1553": 1,
  "53nt-l@-pi553": 1,
  "53nt-la-p!553": 1,
  "53nt-la-p1553": 1,
  "53nt-la-pi553": 1,
  "5ag0u!n": 1,
  "5ag0u1n": 1,
  "5ag0uin": 1,
  "5agou!n": 1,
  "5agou1n": 1,
  "5agouin": 1,
  "5al0p": 1,
  "5al0p3": 1,
  "5al0pard": 1,
  "5al0pe": 1,
  "5al3": 1,
  "5alaud": 1,
  "5ale": 1,
  "5alop": 1,
  "5alop3": 1,
  "5alopard": 1,
  "5alope": 1,
  "5atr0u!ll3": 1,
  "5atr0u!lle": 1,
  "5atr0u1ll3": 1,
  "5atr0u1lle": 1,
  "5atr0uill3": 1,
  "5atr0uille": 1,
  "5atrou!ll3": 1,
  "5atrou!lle": 1,
  "5atrou1ll3": 1,
  "5atrou1lle": 1,
  "5atrouill3": 1,
  "5atrouille": 1,
  "5chb3b": 1,
  "5chbeb": 1,
  "5chl3u": 1,
  "5chleu": 1,
  "5chn0c": 1,
  "5chn0ck": 1,
  "5chn0qu3": 1,
  "5chn0que": 1,
  "5chnoc": 1,
  "5chnock": 1,
  "5chnoqu3": 1,
  "5chnoque": 1,
  "5ent-l@-p!55e": 1,
  "5ent-l@-p155e": 1,
  "5ent-l@-pi55e": 1,
  "5ent-la-p!55e": 1,
  "5ent-la-p155e": 1,
  "5ent-la-pi55e": 1,
  "5ott!53ux": 1,
  "5ott!5eux": 1,
  "5ott153ux": 1,
  "5ott15eux": 1,
  "5otti53ux": 1,
  "5otti5eux": 1,
  "5ou5-m3rd3": 1,
  "5ou5-merde": 1,
  "5t3@r!qu3": 1,
  "5t3@r1qu3": 1,
  "5t3@riqu3": 1,
  "5t3ar!qu3": 1,
  "5t3ar1qu3": 1,
  "5t3ariqu3": 1,
  "5té@r!qu3": 1,
  "5te@r!que": 1,
  "5té@r!que": 1,
  "5te@r1qu3": 1,
  "5té@r1qu3": 1,
  "5te@r1que": 1,
  "5té@r1que": 1,
  "5te@riqu3": 1,
  "5té@riqu3": 1,
  "5te@rique": 1,
  "5té@rique": 1,
  "5tear!qu3": 1,
  "5téar!qu3": 1,
  "5tear!que": 1,
  "5téar!que": 1,
  "5tear1qu3": 1,
  "5téar1qu3": 1,
  "5tear1que": 1,
  "5téar1que": 1,
  "5teariqu3": 1,
  "5téariqu3": 1,
  "5tearique": 1,
  "5téarique": 1,
  "abrut!": 1,
  abrut1: 1,
  abruti: 1,
  "and0u!ll3": 1,
  "and0u!lle": 1,
  and0u1ll3: 1,
  and0u1lle: 1,
  and0uill3: 1,
  and0uille: 1,
  "andou!ll3": 1,
  "andou!lle": 1,
  andou1ll3: 1,
  andou1lle: 1,
  andouill3: 1,
  andouille: 1,
  av0rt0n: 1,
  avorton: 1,
  "b!@tch": 1,
  "b!atch": 1,
  "b!c0t": 1,
  "b!cot": 1,
  "b!t3": 1,
  "b!t3mb0!5": 1,
  "b!t3mb0!s": 1,
  "b!t3mbo!5": 1,
  "b!t3mbo!s": 1,
  "b!te": 1,
  "b!temb0!5": 1,
  "b!temb0!s": 1,
  "b!tembo!5": 1,
  "b!tembo!s": 1,
  "b@t@rd": 1,
  b0rd3l: 1,
  b0rdel: 1,
  b0uff0n: 1,
  b0ugn0ul: 1,
  "B0ugn0ul!3": 1,
  "b0ugn0ul!5@t!0n": 1,
  "b0ugn0ul!53r": 1,
  "b0ugn0ul!5at!0n": 1,
  "b0ugn0ul!5er": 1,
  "B0ugn0ul!e": 1,
  "b0ugn0ul!s@t!0n": 1,
  "b0ugn0ul!s3r": 1,
  "b0ugn0ul!sat!0n": 1,
  "b0ugn0ul!ser": 1,
  B0ugn0ul13: 1,
  "b0ugn0ul15@t10n": 1,
  b0ugn0ul153r: 1,
  b0ugn0ul15at10n: 1,
  b0ugn0ul15er: 1,
  B0ugn0ul1e: 1,
  "b0ugn0ul1s@t10n": 1,
  b0ugn0ul1s3r: 1,
  b0ugn0ul1sat10n: 1,
  b0ugn0ul1ser: 1,
  b0ugn0ul3: 1,
  b0ugn0ule: 1,
  B0ugn0uli3: 1,
  "b0ugn0uli5@ti0n": 1,
  b0ugn0uli53r: 1,
  b0ugn0uli5ati0n: 1,
  b0ugn0uli5er: 1,
  B0ugn0ulie: 1,
  "b0ugn0ulis@ti0n": 1,
  b0ugn0ulis3r: 1,
  b0ugn0ulisati0n: 1,
  b0ugn0uliser: 1,
  b0ugr3: 1,
  b0ugre: 1,
  "b0uk@k": 1,
  b0ukak: 1,
  "b0un!0ul": 1,
  b0un10ul: 1,
  b0uni0ul: 1,
  "b0urd!ll3": 1,
  "b0urd!lle": 1,
  b0urd1ll3: 1,
  b0urd1lle: 1,
  b0urdill3: 1,
  b0urdille: 1,
  b0us3ux: 1,
  b0useux: 1,
  "b1@tch": 1,
  b1atch: 1,
  b1c0t: 1,
  b1cot: 1,
  b1t3: 1,
  b1t3mb015: 1,
  b1t3mb01s: 1,
  b1t3mbo15: 1,
  b1t3mbo1s: 1,
  b1te: 1,
  b1temb015: 1,
  b1temb01s: 1,
  b1tembo15: 1,
  b1tembo1s: 1,
  "b3@uf": 1,
  b3auf: 1,
  "bât@rd": 1,
  batard: 1,
  "bâtard": 1,
  "be@uf": 1,
  beauf: 1,
  "bi@tch": 1,
  biatch: 1,
  bic0t: 1,
  bicot: 1,
  bit3: 1,
  bit3mb0i5: 1,
  bit3mb0is: 1,
  bit3mboi5: 1,
  bit3mbois: 1,
  bite: 1,
  bitemb0i5: 1,
  bitemb0is: 1,
  bitemboi5: 1,
  bitembois: 1,
  bord3l: 1,
  bordel: 1,
  bouffon: 1,
  bougnoul: 1,
  "Bougnoul!3": 1,
  "bougnoul!5@t!on": 1,
  "bougnoul!53r": 1,
  "bougnoul!5at!on": 1,
  "bougnoul!5er": 1,
  "Bougnoul!e": 1,
  "bougnoul!s@t!on": 1,
  "bougnoul!s3r": 1,
  "bougnoul!sat!on": 1,
  "bougnoul!ser": 1,
  Bougnoul13: 1,
  "bougnoul15@t1on": 1,
  bougnoul153r: 1,
  bougnoul15at1on: 1,
  bougnoul15er: 1,
  Bougnoul1e: 1,
  "bougnoul1s@t1on": 1,
  bougnoul1s3r: 1,
  bougnoul1sat1on: 1,
  bougnoul1ser: 1,
  bougnoul3: 1,
  bougnoule: 1,
  Bougnouli3: 1,
  "bougnouli5@tion": 1,
  bougnouli53r: 1,
  bougnouli5ation: 1,
  bougnouli5er: 1,
  Bougnoulie: 1,
  "bougnoulis@tion": 1,
  bougnoulis3r: 1,
  bougnoulisation: 1,
  bougnouliser: 1,
  bougr3: 1,
  bougre: 1,
  "bouk@k": 1,
  boukak: 1,
  "boun!oul": 1,
  boun1oul: 1,
  bounioul: 1,
  "bourd!ll3": 1,
  "bourd!lle": 1,
  bourd1ll3: 1,
  bourd1lle: 1,
  bourdill3: 1,
  bourdille: 1,
  bous3ux: 1,
  bouseux: 1,
  "br!53-burn35": 1,
  "br!5e-burne5": 1,
  "br!s3-burn3s": 1,
  "br!se-burnes": 1,
  "br@nl3r": 1,
  "br@nl3ur": 1,
  "br@nler": 1,
  "br@nleur": 1,
  "br@nqu3": 1,
  "br@nque": 1,
  "br153-burn35": 1,
  "br15e-burne5": 1,
  "br1s3-burn3s": 1,
  "br1se-burnes": 1,
  branl3r: 1,
  branl3ur: 1,
  branler: 1,
  branleur: 1,
  branqu3: 1,
  branque: 1,
  "bri53-burn35": 1,
  "bri5e-burne5": 1,
  "bris3-burn3s": 1,
  "brise-burnes": 1,
  "c@553-b0nb0n": 1,
  "c@553-bonbon": 1,
  "c@553-c0u!ll3": 1,
  "c@553-c0u!ll35": 1,
  "c@553-c0u1ll3": 1,
  "c@553-c0u1ll35": 1,
  "c@553-c0uill3": 1,
  "c@553-c0uill35": 1,
  "c@553-cou!ll3": 1,
  "c@553-cou!ll35": 1,
  "c@553-cou1ll3": 1,
  "c@553-cou1ll35": 1,
  "c@553-couill3": 1,
  "c@553-couill35": 1,
  "c@55e-b0nb0n": 1,
  "c@55e-bonbon": 1,
  "c@55e-c0u!lle": 1,
  "c@55e-c0u!lle5": 1,
  "c@55e-c0u1lle": 1,
  "c@55e-c0u1lle5": 1,
  "c@55e-c0uille": 1,
  "c@55e-c0uille5": 1,
  "c@55e-cou!lle": 1,
  "c@55e-cou!lle5": 1,
  "c@55e-cou1lle": 1,
  "c@55e-cou1lle5": 1,
  "c@55e-couille": 1,
  "c@55e-couille5": 1,
  "c@c0u": 1,
  "c@cou": 1,
  "c@fr3": 1,
  "c@fre": 1,
  "c@ld0ch3": 1,
  "c@ld0che": 1,
  "c@ldoch3": 1,
  "c@ldoche": 1,
  "c@ss3-b0nb0n": 1,
  "c@ss3-bonbon": 1,
  "c@ss3-c0u!ll3": 1,
  "c@ss3-c0u!ll3s": 1,
  "c@ss3-c0u1ll3": 1,
  "c@ss3-c0u1ll3s": 1,
  "c@ss3-c0uill3": 1,
  "c@ss3-c0uill3s": 1,
  "c@ss3-cou!ll3": 1,
  "c@ss3-cou!ll3s": 1,
  "c@ss3-cou1ll3": 1,
  "c@ss3-cou1ll3s": 1,
  "c@ss3-couill3": 1,
  "c@ss3-couill3s": 1,
  "c@sse-b0nb0n": 1,
  "c@sse-bonbon": 1,
  "c@sse-c0u!lle": 1,
  "c@sse-c0u!lles": 1,
  "c@sse-c0u1lle": 1,
  "c@sse-c0u1lles": 1,
  "c@sse-c0uille": 1,
  "c@sse-c0uilles": 1,
  "c@sse-cou!lle": 1,
  "c@sse-cou!lles": 1,
  "c@sse-cou1lle": 1,
  "c@sse-cou1lles": 1,
  "c@sse-couille": 1,
  "c@sse-couilles": 1,
  c0ch3: 1,
  c0che: 1,
  c0n: 1,
  "c0n@553": 1,
  "c0n@55e": 1,
  "c0n@rd": 1,
  "c0n@ss3": 1,
  "c0n@sse": 1,
  c0n5: 1,
  c0na553: 1,
  c0na55e: 1,
  c0nard: 1,
  c0nass3: 1,
  c0nasse: 1,
  "c0nch!3r": 1,
  "c0nch!er": 1,
  c0nch13r: 1,
  c0nch1er: 1,
  c0nchi3r: 1,
  c0nchier: 1,
  "c0nn@553": 1,
  "c0nn@55e": 1,
  "c0nn@rd": 1,
  "c0nn@rd3": 1,
  "c0nn@rde": 1,
  "c0nn@ss3": 1,
  "c0nn@sse": 1,
  c0nn3: 1,
  c0nna553: 1,
  c0nna55e: 1,
  c0nnard: 1,
  c0nnard3: 1,
  c0nnarde: 1,
  c0nnass3: 1,
  c0nnasse: 1,
  c0nne: 1,
  c0ns: 1,
  c0u1ll0n: 1,
  c0u1ll0nn3r: 1,
  c0u1ll3: 1,
  c0u1ll3s: 1,
  c0uill0n: 1,
  c0uill0nn3r: 1,
  c0uill0nner: 1,
  c0uill3: 1,
  c0uill3s: 1,
  c0uille: 1,
  c0uilles: 1,
  "c0un!fl3": 1,
  "c0un!fle": 1,
  c0un1fl3: 1,
  c0un1fle: 1,
  c0unifl3: 1,
  c0unifle: 1,
  "c0urt@ud": 1,
  c0urtaud: 1,
  "ca553-b0nb0n": 1,
  "ca553-bonbon": 1,
  "ca553-c0u!ll3": 1,
  "ca553-c0u!ll35": 1,
  "ca553-c0u1ll3": 1,
  "ca553-c0u1ll35": 1,
  "ca553-c0uill3": 1,
  "ca553-c0uill35": 1,
  "ca553-cou!ll3": 1,
  "ca553-cou!ll35": 1,
  "ca553-cou1ll3": 1,
  "ca553-cou1ll35": 1,
  "ca553-couill3": 1,
  "ca553-couill35": 1,
  "ca55e-b0nb0n": 1,
  "ca55e-bonbon": 1,
  "ca55e-c0u!lle": 1,
  "ca55e-c0u!lle5": 1,
  "ca55e-c0u1lle": 1,
  "ca55e-c0u1lle5": 1,
  "ca55e-c0uille": 1,
  "ca55e-c0uille5": 1,
  "ca55e-cou!lle": 1,
  "ca55e-cou!lle5": 1,
  "ca55e-cou1lle": 1,
  "ca55e-cou1lle5": 1,
  "ca55e-couille": 1,
  "ca55e-couille5": 1,
  cac0u: 1,
  cacou: 1,
  cafr3: 1,
  cafre: 1,
  cald0ch3: 1,
  cald0che: 1,
  caldoch3: 1,
  caldoche: 1,
  "cass3-b0nb0n": 1,
  "cass3-bonbon": 1,
  "cass3-c0u!ll3": 1,
  "cass3-c0u!ll3s": 1,
  "cass3-c0u1ll3": 1,
  "cass3-c0u1ll3s": 1,
  "cass3-c0uill3": 1,
  "cass3-c0uill3s": 1,
  "cass3-cou!ll3": 1,
  "cass3-cou!ll3s": 1,
  "cass3-cou1ll3": 1,
  "cass3-cou1ll3s": 1,
  "cass3-couill3": 1,
  "cass3-couill3s": 1,
  "casse-b0nb0n": 1,
  "casse-bonbon": 1,
  "casse-c0u!lle": 1,
  "casse-c0u!lles": 1,
  "casse-c0u1lle": 1,
  "casse-c0u1lles": 1,
  "casse-c0uille": 1,
  "casse-c0uilles": 1,
  "casse-cou!lle": 1,
  "casse-cou!lles": 1,
  "casse-cou1lle": 1,
  "casse-cou1lles": 1,
  "casse-couille": 1,
  "casse-couilles": 1,
  "ch!3nn@553": 1,
  "ch!3nn@ss3": 1,
  "ch!3nna553": 1,
  "ch!3nnass3": 1,
  "ch!3r": 1,
  "ch!enn@55e": 1,
  "ch!enn@sse": 1,
  "ch!enna55e": 1,
  "ch!ennasse": 1,
  "ch!er": 1,
  "ch!n3t0c": 1,
  "ch!n3t0qu3": 1,
  "ch!n3toc": 1,
  "ch!n3toqu3": 1,
  "ch!net0c": 1,
  "ch!net0que": 1,
  "ch!netoc": 1,
  "ch!netoque": 1,
  "ch!nt0k": 1,
  "ch!ntok": 1,
  "ch@ch@r": 1,
  "ch@g@553": 1,
  "ch@g@55e": 1,
  "ch@g@ss3": 1,
  "ch@g@sse": 1,
  "ch@uff@rd": 1,
  "ch13nn@553": 1,
  "ch13nn@ss3": 1,
  ch13nna553: 1,
  ch13nnass3: 1,
  ch13r: 1,
  ch13ur: 1,
  ch13urs: 1,
  "ch1enn@55e": 1,
  "ch1enn@sse": 1,
  ch1enna55e: 1,
  ch1ennasse: 1,
  ch1er: 1,
  ch1eur: 1,
  ch1eurs: 1,
  ch1n3t0c: 1,
  ch1n3t0qu3: 1,
  ch1n3toc: 1,
  ch1n3toqu3: 1,
  ch1net0c: 1,
  ch1net0que: 1,
  ch1netoc: 1,
  ch1netoque: 1,
  ch1nt0k: 1,
  ch1ntok: 1,
  chachar: 1,
  chaga553: 1,
  chaga55e: 1,
  chagass3: 1,
  chagasse: 1,
  chauffard: 1,
  "chi3nn@553": 1,
  "chi3nn@ss3": 1,
  chi3nna553: 1,
  chi3nnass3: 1,
  chi3r: 1,
  chi3ur: 1,
  chi3urs: 1,
  "chienn@55e": 1,
  "chienn@sse": 1,
  chienna55e: 1,
  chiennasse: 1,
  chier: 1,
  chieur: 1,
  chieurs: 1,
  chin3t0c: 1,
  chin3t0qu3: 1,
  chin3toc: 1,
  chin3toqu3: 1,
  chinet0c: 1,
  chinet0que: 1,
  chinetoc: 1,
  chinetoque: 1,
  chint0k: 1,
  chintok: 1,
  chl3uh: 1,
  chleuh: 1,
  chn0qu3: 1,
  chn0que: 1,
  chnoqu3: 1,
  chnoque: 1,
  coch3: 1,
  coche: 1,
  con: 1,
  "con@553": 1,
  "con@55e": 1,
  "con@rd": 1,
  "con@ss3": 1,
  "con@sse": 1,
  con5: 1,
  cona553: 1,
  cona55e: 1,
  conard: 1,
  conass3: 1,
  conasse: 1,
  "conch!3r": 1,
  "conch!er": 1,
  conch13r: 1,
  conch1er: 1,
  conchi3r: 1,
  conchier: 1,
  "conn@553": 1,
  "conn@55e": 1,
  "conn@rd": 1,
  "conn@rd3": 1,
  "conn@rde": 1,
  "conn@ss3": 1,
  "conn@sse": 1,
  conn3: 1,
  conna553: 1,
  conna55e: 1,
  connard: 1,
  connard3: 1,
  connarde: 1,
  connass3: 1,
  connasse: 1,
  conne: 1,
  cons: 1,
  cou1lle: 1,
  cou1lles: 1,
  cou1llon: 1,
  cou1llonner: 1,
  couill3: 1,
  couill3s: 1,
  couille: 1,
  couilles: 1,
  couillon: 1,
  couillonn3r: 1,
  couillonner: 1,
  "coun!fl3": 1,
  "coun!fle": 1,
  coun1fl3: 1,
  coun1fle: 1,
  counifl3: 1,
  counifle: 1,
  "court@ud": 1,
  courtaud: 1,
  "cr!cr!": 1,
  cr0tt3: 1,
  cr0tte: 1,
  "cr0tté": 1,
  "cr0u!ll@t": 1,
  "cr0u!ll3": 1,
  "cr0u!llat": 1,
  "cr0u!lle": 1,
  "cr0u1ll@t": 1,
  cr0u1ll3: 1,
  cr0u1llat: 1,
  cr0u1lle: 1,
  "cr0uill@t": 1,
  cr0uill3: 1,
  cr0uillat: 1,
  cr0uille: 1,
  "cr0ût0n": 1,
  cr1cr1: 1,
  "cr3t!n": 1,
  cr3t1n: 1,
  cr3tin: 1,
  "cr3v@rd": 1,
  cr3vard: 1,
  cr3vur3: 1,
  "cret!n": 1,
  "crét!n": 1,
  cret1n: 1,
  "crét1n": 1,
  cretin: 1,
  "crétin": 1,
  "crev@rd": 1,
  crevard: 1,
  crevure: 1,
  cricri: 1,
  crott3: 1,
  crotte: 1,
  "crotté": 1,
  "crou!ll@t": 1,
  "crou!ll3": 1,
  "crou!llat": 1,
  "crou!lle": 1,
  "crou1ll@t": 1,
  crou1ll3: 1,
  crou1llat: 1,
  crou1lle: 1,
  "crouill@t": 1,
  crouill3: 1,
  crouillat: 1,
  crouille: 1,
  "croûton": 1,
  cul: 1,
  "d3b!l3": 1,
  d3b1l3: 1,
  d3bil3: 1,
  "d3gu3l@ss3": 1,
  d3gu3lass3: 1,
  d3m3rd3r: 1,
  "deb!l3": 1,
  "déb!l3": 1,
  "deb!le": 1,
  "déb!le": 1,
  deb1l3: 1,
  "déb1l3": 1,
  deb1le: 1,
  "déb1le": 1,
  debil3: 1,
  "débil3": 1,
  debile: 1,
  "débile": 1,
  "déguel@sse": 1,
  deguelasse: 1,
  "déguelasse": 1,
  demerder: 1,
  "démerder": 1,
  "dr0u!ll3": 1,
  "dr0u!lle": 1,
  dr0u1ll3: 1,
  dr0u1lle: 1,
  dr0uill3: 1,
  dr0uille: 1,
  "drou!ll3": 1,
  "drou!lle": 1,
  drou1ll3: 1,
  drou1lle: 1,
  drouill3: 1,
  drouille: 1,
  "du schn0c": 1,
  "du schnoc": 1,
  du5chn0ck: 1,
  du5chnock: 1,
  duc0n: 1,
  duc0nn0t: 1,
  ducon: 1,
  duconnot: 1,
  dug3n0ux: 1,
  dug3noux: 1,
  dugen0ux: 1,
  dugenoux: 1,
  "dugl@nd": 1,
  dugland: 1,
  duschn0ck: 1,
  duschnock: 1,
  "e5p!ng0!n": 1,
  "e5p!ngo!n": 1,
  e5p1ng01n: 1,
  e5p1ngo1n: 1,
  e5ping0in: 1,
  e5pingoin: 1,
  "emm@nche": 1,
  "emm@nché": 1,
  emmanche: 1,
  "emmanché": 1,
  emmerder: 1,
  emmerdeu5e: 1,
  emmerdeur: 1,
  emmerdeuse: 1,
  "emp@fe": 1,
  "emp@fé": 1,
  "emp@p@0ute": 1,
  "emp@p@0uté": 1,
  "emp@p@oute": 1,
  "emp@p@outé": 1,
  empafe: 1,
  "empafé": 1,
  empapa0ute: 1,
  "empapa0uté": 1,
  empapaoute: 1,
  "empapaouté": 1,
  encule: 1,
  "enculé": 1,
  enculer: 1,
  enculeur: 1,
  "enf0!re": 1,
  "enf0!ré": 1,
  enf01re: 1,
  "enf01ré": 1,
  enf0ire: 1,
  "enf0iré": 1,
  enflure: 1,
  "enfo!re": 1,
  "enfo!ré": 1,
  enfo1re: 1,
  "enfo1ré": 1,
  enfoire: 1,
  "enfoiré": 1,
  "env@5el!neur": 1,
  "env@5el1neur": 1,
  "env@5elineur": 1,
  "env@sel!neur": 1,
  "env@sel1neur": 1,
  "env@selineur": 1,
  "enva5el!neur": 1,
  enva5el1neur: 1,
  enva5elineur: 1,
  "envasel!neur": 1,
  envasel1neur: 1,
  envaselineur: 1,
  "ep@!5": 1,
  "ép@!5": 1,
  "ep@!s": 1,
  "ép@!s": 1,
  "ep@15": 1,
  "ép@15": 1,
  "ep@1s": 1,
  "ép@1s": 1,
  "ep@i5": 1,
  "ép@i5": 1,
  "ep@is": 1,
  "ép@is": 1,
  "epa!5": 1,
  "épa!5": 1,
  "epa!s": 1,
  "épa!s": 1,
  epa15: 1,
  "épa15": 1,
  epa1s: 1,
  "épa1s": 1,
  epai5: 1,
  "épai5": 1,
  epais: 1,
  "épais": 1,
  "esp!ng0!n": 1,
  "esp!ngo!n": 1,
  esp1ng01n: 1,
  esp1ngo1n: 1,
  esping0in: 1,
  espingoin: 1,
  etr0n: 1,
  "étr0n": 1,
  etron: 1,
  "étron": 1,
  "f!0tt3": 1,
  "f!0tte": 1,
  "f!ott3": 1,
  "f!otte": 1,
  f0ut3ur: 1,
  f0uteur: 1,
  f0utr3: 1,
  f0utre: 1,
  f10tt3: 1,
  f10tte: 1,
  f1ott3: 1,
  f1otte: 1,
  "f31gn@ss3": 1,
  "f3ign@ss3": 1,
  f3ignass3: 1,
  FDP: 1,
  fe1gnasse: 1,
  "feign@sse": 1,
  feignasse: 1,
  fi0tt3: 1,
  fi0tte: 1,
  fiott3: 1,
  fiotte: 1,
  fout3ur: 1,
  fouteur: 1,
  foutr3: 1,
  foutre: 1,
  "fr!tz": 1,
  fr1tz: 1,
  fritz: 1,
  "fum!3r": 1,
  "fum!er": 1,
  fum13r: 1,
  fum1er: 1,
  fumi3r: 1,
  fumier: 1,
  "g@rc3": 1,
  "g@rce": 1,
  "g@up3": 1,
  "g@upe": 1,
  G0d0n: 1,
  g0g0l: 1,
  "g0ï": 1,
  "g0u!ll@nd": 1,
  "g0u!lland": 1,
  "g0u!n3": 1,
  "g0u!ne": 1,
  "g0u1ll@nd": 1,
  g0u1lland: 1,
  g0u1n3: 1,
  g0u1ne: 1,
  "g0uill@nd": 1,
  g0uilland: 1,
  g0uin3: 1,
  g0uine: 1,
  g0urd3: 1,
  g0urde: 1,
  "g0urg@nd!n3": 1,
  "g0urg@nd!ne": 1,
  "g0urg@nd1n3": 1,
  "g0urg@nd1ne": 1,
  "g0urg@ndin3": 1,
  "g0urg@ndine": 1,
  "g0urgand!n3": 1,
  "g0urgand!ne": 1,
  g0urgand1n3: 1,
  g0urgand1ne: 1,
  g0urgandin3: 1,
  g0urgandine: 1,
  garc3: 1,
  garce: 1,
  gaup3: 1,
  gaupe: 1,
  GDM: 1,
  "gl@nd": 1,
  "gl@nd0u!ll0u": 1,
  "gl@nd0u1ll0u": 1,
  "gl@nd0uill0u": 1,
  "gl@nd3u53": 1,
  "gl@nd3ur": 1,
  "gl@nd3us3": 1,
  "gl@ndeu5e": 1,
  "gl@ndeur": 1,
  "gl@ndeuse": 1,
  "gl@ndou!llou": 1,
  "gl@ndou1llou": 1,
  "gl@ndouillou": 1,
  "gl@ndu": 1,
  gland: 1,
  "gland0u!ll0u": 1,
  gland0u1ll0u: 1,
  gland0uill0u: 1,
  gland3u53: 1,
  gland3ur: 1,
  gland3us3: 1,
  glandeu5e: 1,
  glandeur: 1,
  glandeuse: 1,
  "glandou!llou": 1,
  glandou1llou: 1,
  glandouillou: 1,
  glandu: 1,
  gn0ul: 1,
  gn0ul3: 1,
  gn0ule: 1,
  gnoul: 1,
  gnoul3: 1,
  gnoule: 1,
  Godon: 1,
  gogol: 1,
  "goï": 1,
  "gou!ll@nd": 1,
  "gou!lland": 1,
  "gou!n3": 1,
  "gou!ne": 1,
  "gou1ll@nd": 1,
  gou1lland: 1,
  gou1n3: 1,
  gou1ne: 1,
  "gouill@nd": 1,
  gouilland: 1,
  gouin3: 1,
  gouine: 1,
  gourd3: 1,
  gourde: 1,
  "gourg@nd!n3": 1,
  "gourg@nd!ne": 1,
  "gourg@nd1n3": 1,
  "gourg@nd1ne": 1,
  "gourg@ndin3": 1,
  "gourg@ndine": 1,
  "gourgand!n3": 1,
  "gourgand!ne": 1,
  gourgand1n3: 1,
  gourgand1ne: 1,
  gourgandin3: 1,
  gourgandine: 1,
  "gr0gn@553": 1,
  "gr0gn@55e": 1,
  "gr0gn@ss3": 1,
  "gr0gn@sse": 1,
  gr0gna553: 1,
  gr0gna55e: 1,
  gr0gnass3: 1,
  gr0gnasse: 1,
  "grogn@553": 1,
  "grogn@55e": 1,
  "grogn@ss3": 1,
  "grogn@sse": 1,
  grogna553: 1,
  grogna55e: 1,
  grognass3: 1,
  grognasse: 1,
  "gu!nd0ul3": 1,
  "gu!nd0ule": 1,
  "gu!ndoul3": 1,
  "gu!ndoule": 1,
  gu1nd0ul3: 1,
  gu1nd0ule: 1,
  gu1ndoul3: 1,
  gu1ndoule: 1,
  "gu3n!ch3": 1,
  gu3n1ch3: 1,
  gu3nich3: 1,
  "guen!che": 1,
  guen1che: 1,
  gueniche: 1,
  guind0ul3: 1,
  guind0ule: 1,
  guindoul3: 1,
  guindoule: 1,
  imb3cil3: 1,
  imbecil3: 1,
  "imbécil3": 1,
  imbecile: 1,
  "imbécile": 1,
  "j3@n-f0utr3": 1,
  "j3@n-foutr3": 1,
  "j3an-f0utr3": 1,
  "j3an-foutr3": 1,
  "je@n-f0utre": 1,
  "je@n-foutre": 1,
  "jean-f0utre": 1,
  "jean-foutre": 1,
  "k!k00": 1,
  "k!k0u": 1,
  "k!koo": 1,
  "k!kou": 1,
  k1k00: 1,
  k1k0u: 1,
  k1koo: 1,
  k1kou: 1,
  kik00: 1,
  kik0u: 1,
  kikoo: 1,
  kikou: 1,
  "Kr@ut": 1,
  Kraut: 1,
  "l@ch3ux": 1,
  "l@cheux": 1,
  "l@v3tt3": 1,
  "l@vette": 1,
  l0p3tt3: 1,
  l0pette: 1,
  lach3ux: 1,
  "lâch3ux": 1,
  lacheux: 1,
  "lâcheux": 1,
  lav3tt3: 1,
  lavette: 1,
  lop3tt3: 1,
  lopette: 1,
  "m!53r@bl3": 1,
  "m!53rabl3": 1,
  "m!5ér@bl3": 1,
  "m!5er@ble": 1,
  "m!5ér@ble": 1,
  "m!5erabl3": 1,
  "m!5érabl3": 1,
  "m!5erable": 1,
  "m!5érable": 1,
  "m!cht0": 1,
  "m!chto": 1,
  "m!n@bl3": 1,
  "m!n@ble": 1,
  "m!nabl3": 1,
  "m!nable": 1,
  "m!nu5": 1,
  "m!nus": 1,
  "m!s3r@bl3": 1,
  "m!s3rabl3": 1,
  "m!ser@bl3": 1,
  "m!sér@bl3": 1,
  "m!ser@ble": 1,
  "m!sér@ble": 1,
  "m!serabl3": 1,
  "m!sérabl3": 1,
  "m!serable": 1,
  "m!sérable": 1,
  "m@g0t": 1,
  "m@got": 1,
  "m@k0um3": 1,
  "m@k0ume": 1,
  "m@k0umé": 1,
  "m@koum3": 1,
  "m@koume": 1,
  "m@koumé": 1,
  "m@nch3": 1,
  "m@nche": 1,
  "m@ng3-m3rd3": 1,
  "m@nge-merde": 1,
  "m@rch@nd0t": 1,
  "m@rch@ndot": 1,
  "m@rg0u!ll!5t3": 1,
  "m@rg0u!ll!5te": 1,
  "m@rg0u!ll!st3": 1,
  "m@rg0u!ll!ste": 1,
  "m@rg0u1ll15t3": 1,
  "m@rg0u1ll15te": 1,
  "m@rg0u1ll1st3": 1,
  "m@rg0u1ll1ste": 1,
  "m@rg0uilli5t3": 1,
  "m@rg0uilli5te": 1,
  "m@rg0uillist3": 1,
  "m@rg0uilliste": 1,
  "m@rgou!ll!5t3": 1,
  "m@rgou!ll!5te": 1,
  "m@rgou!ll!st3": 1,
  "m@rgou!ll!ste": 1,
  "m@rgou1ll15t3": 1,
  "m@rgou1ll15te": 1,
  "m@rgou1ll1st3": 1,
  "m@rgou1ll1ste": 1,
  "m@rgouilli5t3": 1,
  "m@rgouilli5te": 1,
  "m@rgouillist3": 1,
  "m@rgouilliste": 1,
  "m@uv!3tt3": 1,
  "m@uv!ette": 1,
  "m@uv13tt3": 1,
  "m@uv1ette": 1,
  "m@uvi3tt3": 1,
  "m@uviette": 1,
  "m0!n@!ll3": 1,
  "m0!n@!lle": 1,
  "m0!n5-qu3-r!3n": 1,
  "m0!n5-que-r!en": 1,
  "m0!na!ll3": 1,
  "m0!na!lle": 1,
  "m0!ns-qu3-r!3n": 1,
  "m0!ns-que-r!en": 1,
  "m01n@1ll3": 1,
  "m01n@1lle": 1,
  "m01n5-qu3-r13n": 1,
  "m01n5-que-r1en": 1,
  m01na1ll3: 1,
  m01na1lle: 1,
  "m01ns-qu3-r13n": 1,
  "m01ns-que-r1en": 1,
  "m0in@ill3": 1,
  "m0in@ille": 1,
  "m0in5-qu3-ri3n": 1,
  "m0in5-que-rien": 1,
  m0inaill3: 1,
  m0inaille: 1,
  "m0ins-qu3-ri3n": 1,
  "m0ins-que-rien": 1,
  "m0n@c@!ll3": 1,
  "m0n@c@!lle": 1,
  "m0n@c@1ll3": 1,
  "m0n@c@1lle": 1,
  "m0n@c@ill3": 1,
  "m0n@c@ille": 1,
  "m0naca!ll3": 1,
  "m0naca!lle": 1,
  m0naca1ll3: 1,
  m0naca1lle: 1,
  m0nacaill3: 1,
  m0nacaille: 1,
  "m0r!c@ud": 1,
  "m0r!caud": 1,
  "m0r1c@ud": 1,
  m0r1caud: 1,
  "m0ric@ud": 1,
  m0ricaud: 1,
  "m153r@bl3": 1,
  m153rabl3: 1,
  "m15er@bl3": 1,
  "m15ér@bl3": 1,
  "m15er@ble": 1,
  "m15ér@ble": 1,
  m15erabl3: 1,
  "m15érabl3": 1,
  m15erable: 1,
  "m15érable": 1,
  m1cht0: 1,
  m1chto: 1,
  "m1n@bl3": 1,
  "m1n@ble": 1,
  m1nabl3: 1,
  m1nable: 1,
  m1nu5: 1,
  m1nus: 1,
  "m1s3r@bl3": 1,
  m1s3rabl3: 1,
  "m1ser@bl3": 1,
  "m1sér@bl3": 1,
  "m1ser@ble": 1,
  "m1sér@ble": 1,
  m1serabl3: 1,
  "m1sérabl3": 1,
  m1serable: 1,
  "m1sérable": 1,
  "m3rd@!ll0n": 1,
  "m3rd@!ll3": 1,
  "m3rd@!llon": 1,
  "m3rd@1ll0n": 1,
  "m3rd@1ll3": 1,
  "m3rd@1llon": 1,
  "m3rd@ill0n": 1,
  "m3rd@ill3": 1,
  "m3rd@illon": 1,
  "m3rd0u!ll@rd": 1,
  "m3rd0u!llard": 1,
  "m3rd0u1ll@rd": 1,
  m3rd0u1llard: 1,
  "m3rd0uill@rd": 1,
  m3rd0uillard: 1,
  m3rd3: 1,
  m3rd3ux: 1,
  "m3rda!ll0n": 1,
  "m3rda!ll3": 1,
  "m3rda!llon": 1,
  m3rda1ll0n: 1,
  m3rda1ll3: 1,
  m3rda1llon: 1,
  m3rdaill0n: 1,
  m3rdaill3: 1,
  m3rdaillon: 1,
  "m3rdou!ll@rd": 1,
  "m3rdou!llard": 1,
  "m3rdou1ll@rd": 1,
  m3rdou1llard: 1,
  "m3rdouill@rd": 1,
  m3rdouillard: 1,
  mag0t: 1,
  magot: 1,
  mak0um3: 1,
  mak0ume: 1,
  "mak0umé": 1,
  makoum3: 1,
  makoume: 1,
  "makoumé": 1,
  manch3: 1,
  manche: 1,
  "mang3-m3rd3": 1,
  "mange-merde": 1,
  marchand0t: 1,
  marchandot: 1,
  "marg0u!ll!5t3": 1,
  "marg0u!ll!5te": 1,
  "marg0u!ll!st3": 1,
  "marg0u!ll!ste": 1,
  marg0u1ll15t3: 1,
  marg0u1ll15te: 1,
  marg0u1ll1st3: 1,
  marg0u1ll1ste: 1,
  marg0uilli5t3: 1,
  marg0uilli5te: 1,
  marg0uillist3: 1,
  marg0uilliste: 1,
  "margou!ll!5t3": 1,
  "margou!ll!5te": 1,
  "margou!ll!st3": 1,
  "margou!ll!ste": 1,
  margou1ll15t3: 1,
  margou1ll15te: 1,
  margou1ll1st3: 1,
  margou1ll1ste: 1,
  margouilli5t3: 1,
  margouilli5te: 1,
  margouillist3: 1,
  margouilliste: 1,
  "mauv!3tt3": 1,
  "mauv!ette": 1,
  mauv13tt3: 1,
  mauv1ette: 1,
  mauvi3tt3: 1,
  mauviette: 1,
  "merd@!ll0n": 1,
  "merd@!lle": 1,
  "merd@!llon": 1,
  "merd@1ll0n": 1,
  "merd@1lle": 1,
  "merd@1llon": 1,
  "merd@ill0n": 1,
  "merd@ille": 1,
  "merd@illon": 1,
  "merd0u!ll@rd": 1,
  "merd0u!llard": 1,
  "merd0u1ll@rd": 1,
  merd0u1llard: 1,
  "merd0uill@rd": 1,
  merd0uillard: 1,
  "merda!ll0n": 1,
  "merda!lle": 1,
  "merda!llon": 1,
  merda1ll0n: 1,
  merda1lle: 1,
  merda1llon: 1,
  merdaill0n: 1,
  merdaille: 1,
  merdaillon: 1,
  merde: 1,
  merdeux: 1,
  "merdou!ll@rd": 1,
  "merdou!llard": 1,
  "merdou1ll@rd": 1,
  merdou1llard: 1,
  "merdouill@rd": 1,
  merdouillard: 1,
  "mi53r@bl3": 1,
  mi53rabl3: 1,
  "mi5er@bl3": 1,
  "mi5ér@bl3": 1,
  "mi5er@ble": 1,
  "mi5ér@ble": 1,
  mi5erabl3: 1,
  "mi5érabl3": 1,
  mi5erable: 1,
  "mi5érable": 1,
  micht0: 1,
  michto: 1,
  "min@bl3": 1,
  "min@ble": 1,
  minabl3: 1,
  minable: 1,
  minu5: 1,
  minus: 1,
  "mis3r@bl3": 1,
  mis3rabl3: 1,
  "miser@bl3": 1,
  "misér@bl3": 1,
  "miser@ble": 1,
  "misér@ble": 1,
  miserabl3: 1,
  "misérabl3": 1,
  miserable: 1,
  "misérable": 1,
  "mo!n@!ll3": 1,
  "mo!n@!lle": 1,
  "mo!n5-qu3-r!3n": 1,
  "mo!n5-que-r!en": 1,
  "mo!na!ll3": 1,
  "mo!na!lle": 1,
  "mo!ns-qu3-r!3n": 1,
  "mo!ns-que-r!en": 1,
  "mo1n@1ll3": 1,
  "mo1n@1lle": 1,
  "mo1n5-qu3-r13n": 1,
  "mo1n5-que-r1en": 1,
  mo1na1ll3: 1,
  mo1na1lle: 1,
  "mo1ns-qu3-r13n": 1,
  "mo1ns-que-r1en": 1,
  "moin@ill3": 1,
  "moin@ille": 1,
  "moin5-qu3-ri3n": 1,
  "moin5-que-rien": 1,
  moinaill3: 1,
  moinaille: 1,
  "moins-qu3-ri3n": 1,
  "moins-que-rien": 1,
  "mon@c@!ll3": 1,
  "mon@c@!lle": 1,
  "mon@c@1ll3": 1,
  "mon@c@1lle": 1,
  "mon@c@ill3": 1,
  "mon@c@ille": 1,
  "monaca!ll3": 1,
  "monaca!lle": 1,
  monaca1ll3: 1,
  monaca1lle: 1,
  monacaill3: 1,
  monacaille: 1,
  "mor!c@ud": 1,
  "mor!caud": 1,
  "mor1c@ud": 1,
  mor1caud: 1,
  "moric@ud": 1,
  moricaud: 1,
  "n!@!53ux": 1,
  "n!@!5eux": 1,
  "n!@!s3ux": 1,
  "n!@!seux": 1,
  "n!@c": 1,
  "n!@k0u3": 1,
  "n!@k0ue": 1,
  "n!@k0ué": 1,
  "n!@kou3": 1,
  "n!@koue": 1,
  "n!@koué": 1,
  "n!a!53ux": 1,
  "n!a!5eux": 1,
  "n!a!s3ux": 1,
  "n!a!seux": 1,
  "n!ac": 1,
  "n!ak0u3": 1,
  "n!ak0ue": 1,
  "n!ak0ué": 1,
  "n!akou3": 1,
  "n!akoue": 1,
  "n!akoué": 1,
  "n!qu3": 1,
  "n!qu3r": 1,
  "n!que": 1,
  "n!quer": 1,
  "n@s3": 1,
  "n@se": 1,
  "n@z3": 1,
  "n@ze": 1,
  "n1@153ux": 1,
  "n1@15eux": 1,
  "n1@1s3ux": 1,
  "n1@1seux": 1,
  "n1@c": 1,
  "n1@k0u3": 1,
  "n1@k0ue": 1,
  "n1@k0ué": 1,
  "n1@kou3": 1,
  "n1@koue": 1,
  "n1@koué": 1,
  n1a153ux: 1,
  n1a15eux: 1,
  n1a1s3ux: 1,
  n1a1seux: 1,
  n1ac: 1,
  n1ak0u3: 1,
  n1ak0ue: 1,
  "n1ak0ué": 1,
  n1akou3: 1,
  n1akoue: 1,
  "n1akoué": 1,
  n1qu3: 1,
  n1qu3r: 1,
  n1que: 1,
  n1quer: 1,
  n3gr0: 1,
  n3gro: 1,
  nas3: 1,
  nase: 1,
  naz3: 1,
  naze: 1,
  negr0: 1,
  "négr0": 1,
  negro: 1,
  "négro": 1,
  "ni@c": 1,
  "ni@i53ux": 1,
  "ni@i5eux": 1,
  "ni@is3ux": 1,
  "ni@iseux": 1,
  "ni@k0u3": 1,
  "ni@k0ue": 1,
  "ni@k0ué": 1,
  "ni@kou3": 1,
  "ni@koue": 1,
  "ni@koué": 1,
  niac: 1,
  niai53ux: 1,
  niai5eux: 1,
  niais3ux: 1,
  niaiseux: 1,
  niak0u3: 1,
  niak0ue: 1,
  "niak0ué": 1,
  niakou3: 1,
  niakoue: 1,
  "niakoué": 1,
  niqu3: 1,
  niqu3r: 1,
  nique: 1,
  niquer: 1,
  NTM: 1,
  "p!550u": 1,
  "p!55ou": 1,
  "p!gn0uf": 1,
  "p!gnouf": 1,
  "p!ss0u": 1,
  "p!ssou": 1,
  "p@k05": 1,
  "p@k0s": 1,
  "p@ko5": 1,
  "p@kos": 1,
  "p@n0ufl3": 1,
  "p@n0ufle": 1,
  "p@noufl3": 1,
  "p@noufle": 1,
  "p@t@r!n": 1,
  "p@t@r1n": 1,
  "p@t@rin": 1,
  "p0rc@5": 1,
  "p0rc@553": 1,
  "p0rc@55e": 1,
  "p0rc@s": 1,
  "p0rc@ss3": 1,
  "p0rc@sse": 1,
  p0rca5: 1,
  p0rca553: 1,
  p0rca55e: 1,
  p0rcas: 1,
  p0rcass3: 1,
  p0rcasse: 1,
  "p0uc@v": 1,
  p0ucav: 1,
  p0uf: 1,
  "p0uf!@553": 1,
  "p0uf!@55e": 1,
  "p0uf!@ss3": 1,
  "p0uf!@sse": 1,
  "p0uf!a553": 1,
  "p0uf!a55e": 1,
  "p0uf!ass3": 1,
  "p0uf!asse": 1,
  "p0uf1@553": 1,
  "p0uf1@55e": 1,
  "p0uf1@ss3": 1,
  "p0uf1@sse": 1,
  p0uf1a553: 1,
  p0uf1a55e: 1,
  p0uf1ass3: 1,
  p0uf1asse: 1,
  "p0uff!@553": 1,
  "p0uff!@55e": 1,
  "p0uff!@ss3": 1,
  "p0uff!@sse": 1,
  "p0uff!a553": 1,
  "p0uff!a55e": 1,
  "p0uff!ass3": 1,
  "p0uff!asse": 1,
  "p0uff1@553": 1,
  "p0uff1@55e": 1,
  "p0uff1@ss3": 1,
  "p0uff1@sse": 1,
  p0uff1a553: 1,
  p0uff1a55e: 1,
  p0uff1ass3: 1,
  p0uff1asse: 1,
  "p0uffi@553": 1,
  "p0uffi@55e": 1,
  "p0uffi@ss3": 1,
  "p0uffi@sse": 1,
  p0uffia553: 1,
  p0uffia55e: 1,
  p0uffiass3: 1,
  p0uffiasse: 1,
  "p0ufi@553": 1,
  "p0ufi@55e": 1,
  "p0ufi@ss3": 1,
  "p0ufi@sse": 1,
  p0ufia553: 1,
  p0ufia55e: 1,
  p0ufiass3: 1,
  p0ufiasse: 1,
  p0und3: 1,
  p0unde: 1,
  "p0undé": 1,
  "p0urr!tur3": 1,
  "p0urr!ture": 1,
  p0urr1tur3: 1,
  p0urr1ture: 1,
  p0urritur3: 1,
  p0urriture: 1,
  p1550u: 1,
  p155ou: 1,
  p1gn0uf: 1,
  p1gnouf: 1,
  "p1mbêch3": 1,
  "p1mbêche": 1,
  p1ss0u: 1,
  p1ss3ux: 1,
  p1sseux: 1,
  p1ssou: 1,
  p3cqu3: 1,
  "p3d@l3": 1,
  p3d0qu3: 1,
  p3d3: 1,
  p3dal3: 1,
  p3doqu3: 1,
  "p3qu3n@ud": 1,
  p3qu3naud: 1,
  p3t: 1,
  "p3t@553": 1,
  "p3t@ss3": 1,
  p3t3ux: 1,
  p3ta553: 1,
  p3tass3: 1,
  pak05: 1,
  pak0s: 1,
  pako5: 1,
  pakos: 1,
  pan0ufl3: 1,
  pan0ufle: 1,
  panoufl3: 1,
  panoufle: 1,
  "patar!n": 1,
  patar1n: 1,
  patarin: 1,
  PD: 1,
  pecque: 1,
  "ped@l3": 1,
  "péd@l3": 1,
  "ped@le": 1,
  "péd@le": 1,
  ped0qu3: 1,
  "péd0qu3": 1,
  ped0que: 1,
  "péd0que": 1,
  pedal3: 1,
  "pédal3": 1,
  pedale: 1,
  "pédale": 1,
  pede: 1,
  "pédé": 1,
  pedoqu3: 1,
  "pédoqu3": 1,
  pedoque: 1,
  "pédoque": 1,
  "pequ3n@ud": 1,
  "péqu3n@ud": 1,
  pequ3naud: 1,
  "péqu3naud": 1,
  "pequen@ud": 1,
  "péquen@ud": 1,
  pequenaud: 1,
  "péquenaud": 1,
  pet: 1,
  "pét@553": 1,
  "pet@55e": 1,
  "pét@55e": 1,
  "pet@ss3": 1,
  "pét@ss3": 1,
  "pet@sse": 1,
  "pét@sse": 1,
  peta553: 1,
  "péta553": 1,
  peta55e: 1,
  "péta55e": 1,
  petass3: 1,
  "pétass3": 1,
  petasse: 1,
  "pétasse": 1,
  peteux: 1,
  "péteux": 1,
  pi550u: 1,
  pi55ou: 1,
  pign0uf: 1,
  pignouf: 1,
  "pimbêch3": 1,
  "pimbêche": 1,
  piss0u: 1,
  piss3ux: 1,
  pisseux: 1,
  pissou: 1,
  pl0uc: 1,
  pl3utr3: 1,
  pleutre: 1,
  plouc: 1,
  "porc@5": 1,
  "porc@553": 1,
  "porc@55e": 1,
  "porc@s": 1,
  "porc@ss3": 1,
  "porc@sse": 1,
  porca5: 1,
  porca553: 1,
  porca55e: 1,
  porcas: 1,
  porcass3: 1,
  porcasse: 1,
  "pouc@v": 1,
  poucav: 1,
  pouf: 1,
  "pouf!@553": 1,
  "pouf!@55e": 1,
  "pouf!@ss3": 1,
  "pouf!@sse": 1,
  "pouf!a553": 1,
  "pouf!a55e": 1,
  "pouf!ass3": 1,
  "pouf!asse": 1,
  "pouf1@553": 1,
  "pouf1@55e": 1,
  "pouf1@ss3": 1,
  "pouf1@sse": 1,
  pouf1a553: 1,
  pouf1a55e: 1,
  pouf1ass3: 1,
  pouf1asse: 1,
  "pouff!@553": 1,
  "pouff!@55e": 1,
  "pouff!@ss3": 1,
  "pouff!@sse": 1,
  "pouff!a553": 1,
  "pouff!a55e": 1,
  "pouff!ass3": 1,
  "pouff!asse": 1,
  "pouff1@553": 1,
  "pouff1@55e": 1,
  "pouff1@ss3": 1,
  "pouff1@sse": 1,
  pouff1a553: 1,
  pouff1a55e: 1,
  pouff1ass3: 1,
  pouff1asse: 1,
  "pouffi@553": 1,
  "pouffi@55e": 1,
  "pouffi@ss3": 1,
  "pouffi@sse": 1,
  pouffia553: 1,
  pouffia55e: 1,
  pouffiass3: 1,
  pouffiasse: 1,
  "poufi@553": 1,
  "poufi@55e": 1,
  "poufi@ss3": 1,
  "poufi@sse": 1,
  poufia553: 1,
  poufia55e: 1,
  poufiass3: 1,
  poufiasse: 1,
  pound3: 1,
  pounde: 1,
  "poundé": 1,
  "pourr!tur3": 1,
  "pourr!ture": 1,
  pourr1tur3: 1,
  pourr1ture: 1,
  pourritur3: 1,
  pourriture: 1,
  "pun@!53": 1,
  "pun@!5e": 1,
  "pun@!s3": 1,
  "pun@!se": 1,
  "pun@153": 1,
  "pun@15e": 1,
  "pun@1s3": 1,
  "pun@1se": 1,
  "pun@i53": 1,
  "pun@i5e": 1,
  "pun@is3": 1,
  "pun@ise": 1,
  "puna!53": 1,
  "puna!5e": 1,
  "puna!s3": 1,
  "puna!se": 1,
  puna153: 1,
  puna15e: 1,
  puna1s3: 1,
  puna1se: 1,
  punai53: 1,
  punai5e: 1,
  punais3: 1,
  punaise: 1,
  "put!n": 1,
  "put@!n": 1,
  "put@1n": 1,
  "put@in": 1,
  put1n: 1,
  put3: 1,
  "puta!n": 1,
  puta1n: 1,
  putain: 1,
  pute: 1,
  putin: 1,
  "qu3ut@rd": 1,
  qu3utard: 1,
  "queut@rd": 1,
  queutard: 1,
  "r!p0p33": 1,
  "r!p0pe3": 1,
  "r!p0pé3": 1,
  "r!p0pee": 1,
  "r!p0pée": 1,
  "r!pop33": 1,
  "r!pope3": 1,
  "r!popé3": 1,
  "r!popee": 1,
  "r!popée": 1,
  "r@clur3": 1,
  "r@clure": 1,
  "r@t0n": 1,
  "r@ton": 1,
  "r05b!f": 1,
  r05b1f: 1,
  r05bif: 1,
  "r0b35p!3rr0t": 1,
  r0b35p13rr0t: 1,
  r0b35pi3rr0t: 1,
  "r0b3sp!3rr0t": 1,
  r0b3sp13rr0t: 1,
  r0b3spi3rr0t: 1,
  "r0be5p!err0t": 1,
  r0be5p1err0t: 1,
  r0be5pierr0t: 1,
  "r0besp!err0t": 1,
  r0besp1err0t: 1,
  r0bespierr0t: 1,
  "r0sb!f": 1,
  r0sb1f: 1,
  r0sbif: 1,
  r0ulur3: 1,
  r0ulure: 1,
  r1p0p33: 1,
  r1p0pe3: 1,
  "r1p0pé3": 1,
  r1p0pee: 1,
  "r1p0pée": 1,
  r1pop33: 1,
  r1pope3: 1,
  "r1popé3": 1,
  r1popee: 1,
  "r1popée": 1,
  raclur3: 1,
  raclure: 1,
  rat0n: 1,
  raton: 1,
  rip0p33: 1,
  rip0pe3: 1,
  "rip0pé3": 1,
  rip0pee: 1,
  "rip0pée": 1,
  ripop33: 1,
  ripope3: 1,
  "ripopé3": 1,
  ripopee: 1,
  "ripopée": 1,
  "ro5b!f": 1,
  ro5b1f: 1,
  ro5bif: 1,
  "rob35p!3rrot": 1,
  rob35p13rrot: 1,
  rob35pi3rrot: 1,
  "rob3sp!3rrot": 1,
  rob3sp13rrot: 1,
  rob3spi3rrot: 1,
  "robe5p!errot": 1,
  robe5p1errot: 1,
  robe5pierrot: 1,
  "robesp!errot": 1,
  robesp1errot: 1,
  robespierrot: 1,
  "rosb!f": 1,
  rosb1f: 1,
  rosbif: 1,
  roulur3: 1,
  roulure: 1,
  "s@g0u!n": 1,
  "s@g0u1n": 1,
  "s@g0uin": 1,
  "s@gou!n": 1,
  "s@gou1n": 1,
  "s@gouin": 1,
  "s@l@ud": 1,
  "s@l0p": 1,
  "s@l0p@rd": 1,
  "s@l0p3": 1,
  "s@l0p3r13": 1,
  "s@l0p3ri3": 1,
  "s@l0pe": 1,
  "s@l3": 1,
  "s@le": 1,
  "s@lop": 1,
  "s@lop@rd": 1,
  "s@lop3": 1,
  "s@lop3ri3": 1,
  "s@lope": 1,
  "s@loperie": 1,
  "s@tr0u!ll3": 1,
  "s@tr0u!lle": 1,
  "s@tr0u1ll3": 1,
  "s@tr0u1lle": 1,
  "s@tr0uill3": 1,
  "s@tr0uille": 1,
  "s@trou!ll3": 1,
  "s@trou!lle": 1,
  "s@trou1ll3": 1,
  "s@trou1lle": 1,
  "s@trouill3": 1,
  "s@trouille": 1,
  "s0tt!s3ux": 1,
  "s0tt!seux": 1,
  s0tt1s3ux: 1,
  s0tt1seux: 1,
  s0ttis3ux: 1,
  s0ttiseux: 1,
  "s0us-m3rd3": 1,
  "s0us-merde": 1,
  "s3nt-l@-p!ss3": 1,
  "s3nt-l@-p1ss3": 1,
  "s3nt-l@-piss3": 1,
  "s3nt-la-p!ss3": 1,
  "s3nt-la-p1ss3": 1,
  "s3nt-la-piss3": 1,
  "sag0u!n": 1,
  sag0u1n: 1,
  sag0uin: 1,
  "sagou!n": 1,
  sagou1n: 1,
  sagouin: 1,
  sal0p: 1,
  sal0p3: 1,
  sal0pard: 1,
  sal0pe: 1,
  sal0perie: 1,
  sal3: 1,
  salaud: 1,
  sale: 1,
  salop: 1,
  salop3: 1,
  salop3ri3: 1,
  salopard: 1,
  salope: 1,
  saloper1e: 1,
  saloperie: 1,
  "satr0u!ll3": 1,
  "satr0u!lle": 1,
  satr0u1ll3: 1,
  satr0u1lle: 1,
  satr0uill3: 1,
  satr0uille: 1,
  "satrou!ll3": 1,
  "satrou!lle": 1,
  satrou1ll3: 1,
  satrou1lle: 1,
  satrouill3: 1,
  satrouille: 1,
  schb3b: 1,
  schbeb: 1,
  schl3u: 1,
  schleu: 1,
  schn0c: 1,
  schn0ck: 1,
  schn0qu3: 1,
  schn0que: 1,
  schnoc: 1,
  schnock: 1,
  schnoqu3: 1,
  schnoque: 1,
  "sent-l@-p!sse": 1,
  "sent-l@-p1sse": 1,
  "sent-l@-pisse": 1,
  "sent-la-p!sse": 1,
  "sent-la-p1sse": 1,
  "sent-la-pisse": 1,
  "sott!s3ux": 1,
  "sott!seux": 1,
  sott1s3ux: 1,
  sott1seux: 1,
  sottis3ux: 1,
  sottiseux: 1,
  "sous-m3rd3": 1,
  "sous-merde": 1,
  "st3@r!qu3": 1,
  "st3@r1qu3": 1,
  "st3@riqu3": 1,
  "st3ar!qu3": 1,
  st3ar1qu3: 1,
  st3ariqu3: 1,
  "ste@r!qu3": 1,
  "sté@r!qu3": 1,
  "ste@r!que": 1,
  "sté@r!que": 1,
  "ste@r1qu3": 1,
  "sté@r1qu3": 1,
  "ste@r1que": 1,
  "sté@r1que": 1,
  "ste@riqu3": 1,
  "sté@riqu3": 1,
  "ste@rique": 1,
  "sté@rique": 1,
  "stear!qu3": 1,
  "stéar!qu3": 1,
  "stear!que": 1,
  "stéar!que": 1,
  stear1qu3: 1,
  "stéar1qu3": 1,
  stear1que: 1,
  "stéar1que": 1,
  steariqu3: 1,
  "stéariqu3": 1,
  stearique: 1,
  "stéarique": 1,
  "t@f!0l3": 1,
  "t@f!0le": 1,
  "t@f!ol3": 1,
  "t@f!ole": 1,
  "t@f10l3": 1,
  "t@f10le": 1,
  "t@f1ol3": 1,
  "t@f1ole": 1,
  "t@fi0l3": 1,
  "t@fi0le": 1,
  "t@fiol3": 1,
  "t@fiole": 1,
  "t@nt0u53r!3": 1,
  "t@nt0u53r13": 1,
  "t@nt0u53ri3": 1,
  "t@nt0u5er!e": 1,
  "t@nt0u5er1e": 1,
  "t@nt0u5erie": 1,
  "t@nt0us3r!3": 1,
  "t@nt0us3r13": 1,
  "t@nt0us3ri3": 1,
  "t@nt0user!e": 1,
  "t@nt0user1e": 1,
  "t@nt0userie": 1,
  "t@nt0uz3": 1,
  "t@nt0uze": 1,
  "t@ntou53r!3": 1,
  "t@ntou53r13": 1,
  "t@ntou53ri3": 1,
  "t@ntou5er!e": 1,
  "t@ntou5er1e": 1,
  "t@ntou5erie": 1,
  "t@ntous3r!3": 1,
  "t@ntous3r13": 1,
  "t@ntous3ri3": 1,
  "t@ntouser!e": 1,
  "t@ntouser1e": 1,
  "t@ntouserie": 1,
  "t@ntouz3": 1,
  "t@ntouze": 1,
  "t@p3tt3": 1,
  "t@pette": 1,
  "t@rl0uz3": 1,
  "t@rl0uze": 1,
  "t@rlouz3": 1,
  "t@rlouze": 1,
  "t0c@rd": 1,
  t0card: 1,
  t3b3: 1,
  t3be: 1,
  "t3bé": 1,
  t3t3ux: 1,
  t3ub3: 1,
  t3ube: 1,
  "t3ubé": 1,
  "taf!0l3": 1,
  "taf!0le": 1,
  "taf!ol3": 1,
  "taf!ole": 1,
  taf10l3: 1,
  taf10le: 1,
  taf1ol3: 1,
  taf1ole: 1,
  tafi0l3: 1,
  tafi0le: 1,
  tafiol3: 1,
  tafiole: 1,
  "tant0u53r!3": 1,
  tant0u53r13: 1,
  tant0u53ri3: 1,
  "tant0u5er!e": 1,
  tant0u5er1e: 1,
  tant0u5erie: 1,
  "tant0us3r!3": 1,
  tant0us3r13: 1,
  tant0us3ri3: 1,
  "tant0user!e": 1,
  tant0user1e: 1,
  tant0userie: 1,
  tant0uz3: 1,
  tant0uze: 1,
  "tantou53r!3": 1,
  tantou53r13: 1,
  tantou53ri3: 1,
  "tantou5er!e": 1,
  tantou5er1e: 1,
  tantou5erie: 1,
  "tantous3r!3": 1,
  tantous3r13: 1,
  tantous3ri3: 1,
  "tantouser!e": 1,
  tantouser1e: 1,
  tantouserie: 1,
  tantouz3: 1,
  tantouze: 1,
  tap3tt3: 1,
  tapette: 1,
  tarl0uz3: 1,
  tarl0uze: 1,
  tarlouz3: 1,
  tarlouze: 1,
  tebe: 1,
  "tebé": 1,
  tet3ux: 1,
  "tét3ux": 1,
  teteux: 1,
  "téteux": 1,
  teube: 1,
  "teubé": 1,
  "toc@rd": 1,
  tocard: 1,
  "tr@!n33": 1,
  "tr@!nee": 1,
  "tr@1n33": 1,
  "tr@1nee": 1,
  "tr@in33": 1,
  "tr@în33": 1,
  "tr@îne3": 1,
  "tr@îné3": 1,
  "tr@inee": 1,
  "tr@înee": 1,
  "tr@înée": 1,
  tr0uduc: 1,
  "tra!n33": 1,
  "tra!nee": 1,
  tra1n33: 1,
  tra1nee: 1,
  train33: 1,
  "traîn33": 1,
  "traîne3": 1,
  "traîné3": 1,
  trainee: 1,
  "traînee": 1,
  "traînée": 1,
  trouduc: 1,
  "tru!@553": 1,
  "tru!@55e": 1,
  "tru!@ss3": 1,
  "tru!@sse": 1,
  "tru!a553": 1,
  "tru!a55e": 1,
  "tru!ass3": 1,
  "tru!asse": 1,
  "tru1@553": 1,
  "tru1@55e": 1,
  "tru1@ss3": 1,
  "tru1@sse": 1,
  tru1a553: 1,
  tru1a55e: 1,
  tru1ass3: 1,
  tru1asse: 1,
  "trui@553": 1,
  "trui@55e": 1,
  "trui@ss3": 1,
  "trui@sse": 1,
  truia553: 1,
  truia55e: 1,
  truiass3: 1,
  truiasse: 1,
  "v!3d@53": 1,
  "v!3d@s3": 1,
  "v!3da53": 1,
  "v!3das3": 1,
  "v!3r": 1,
  "v!d3-c0u!ll35": 1,
  "v!d3-c0u!ll3s": 1,
  "v!d3-cou!ll35": 1,
  "v!d3-cou!ll3s": 1,
  "v!de-c0u!lle5": 1,
  "v!de-c0u!lles": 1,
  "v!de-cou!lle5": 1,
  "v!de-cou!lles": 1,
  "v!éd@53": 1,
  "v!ed@5e": 1,
  "v!éd@5e": 1,
  "v!ed@s3": 1,
  "v!éd@s3": 1,
  "v!ed@se": 1,
  "v!éd@se": 1,
  "v!eda53": 1,
  "v!éda53": 1,
  "v!eda5e": 1,
  "v!éda5e": 1,
  "v!edas3": 1,
  "v!édas3": 1,
  "v!edase": 1,
  "v!édase": 1,
  "v!er": 1,
  "v@ur!3n": 1,
  "v@ur!en": 1,
  "v@ur13n": 1,
  "v@ur1en": 1,
  "v@uri3n": 1,
  "v@urien": 1,
  "v13d@53": 1,
  "v13d@s3": 1,
  v13da53: 1,
  v13das3: 1,
  v13r: 1,
  "v1d3-c0u1ll35": 1,
  "v1d3-c0u1ll3s": 1,
  "v1d3-cou1ll35": 1,
  "v1d3-cou1ll3s": 1,
  "v1de-c0u1lle5": 1,
  "v1de-c0u1lles": 1,
  "v1de-cou1lle5": 1,
  "v1de-cou1lles": 1,
  "v1ed@53": 1,
  "v1éd@53": 1,
  "v1ed@5e": 1,
  "v1éd@5e": 1,
  "v1ed@s3": 1,
  "v1éd@s3": 1,
  "v1ed@se": 1,
  "v1éd@se": 1,
  v1eda53: 1,
  "v1éda53": 1,
  v1eda5e: 1,
  "v1éda5e": 1,
  v1edas3: 1,
  "v1édas3": 1,
  v1edase: 1,
  "v1édase": 1,
  v1er: 1,
  "vaur!3n": 1,
  "vaur!en": 1,
  vaur13n: 1,
  vaur1en: 1,
  vauri3n: 1,
  vaurien: 1,
  "vi3d@53": 1,
  "vi3d@s3": 1,
  vi3da53: 1,
  vi3das3: 1,
  vi3r: 1,
  "vid3-c0uill35": 1,
  "vid3-c0uill3s": 1,
  "vid3-couill35": 1,
  "vid3-couill3s": 1,
  "vide-c0uille5": 1,
  "vide-c0uilles": 1,
  "vide-couille5": 1,
  "vide-couilles": 1,
  "vied@53": 1,
  "viéd@53": 1,
  "vied@5e": 1,
  "viéd@5e": 1,
  "vied@s3": 1,
  "viéd@s3": 1,
  "vied@se": 1,
  "viéd@se": 1,
  vieda53: 1,
  "viéda53": 1,
  vieda5e: 1,
  "viéda5e": 1,
  viedas3: 1,
  "viédas3": 1,
  viedase: 1,
  "viédase": 1,
  vier: 1,
  "x3r0p!n3ur": 1,
  x3r0p1n3ur: 1,
  x3r0pin3ur: 1,
  "x3rop!n3ur": 1,
  x3rop1n3ur: 1,
  x3ropin3ur: 1,
  "xer0p!n3ur": 1,
  "xér0p!n3ur": 1,
  "xer0p!neur": 1,
  "xér0p!neur": 1,
  xer0p1n3ur: 1,
  "xér0p1n3ur": 1,
  xer0p1neur: 1,
  "xér0p1neur": 1,
  xer0pin3ur: 1,
  "xér0pin3ur": 1,
  xer0pineur: 1,
  "xér0pineur": 1,
  "xerop!n3ur": 1,
  "xérop!n3ur": 1,
  "xerop!neur": 1,
  "xérop!neur": 1,
  xerop1n3ur: 1,
  "xérop1n3ur": 1,
  xerop1neur: 1,
  "xérop1neur": 1,
  xeropin3ur: 1,
  "xéropin3ur": 1,
  xeropineur: 1,
  "xéropineur": 1,
  y0ud: 1,
  "y0up!n": 1,
  "y0up!n!5@t!0n": 1,
  "y0up!n!5at!0n": 1,
  "y0up!n!s@t!0n": 1,
  "y0up!n!sat!0n": 1,
  "y0up!n3": 1,
  "y0up!ne": 1,
  y0up1n: 1,
  "y0up1n15@t10n": 1,
  y0up1n15at10n: 1,
  "y0up1n1s@t10n": 1,
  y0up1n1sat10n: 1,
  y0up1n3: 1,
  y0up1ne: 1,
  y0upin: 1,
  y0upin3: 1,
  y0upine: 1,
  "y0upini5@ti0n": 1,
  y0upini5ati0n: 1,
  "y0upinis@ti0n": 1,
  y0upinisati0n: 1,
  y0utr3: 1,
  y0utre: 1,
  y3ul3: 1,
  yeule: 1,
  youd: 1,
  "youp!n": 1,
  "youp!n!5@t!on": 1,
  "youp!n!5at!on": 1,
  "youp!n!s@t!on": 1,
  "youp!n!sat!on": 1,
  "youp!n3": 1,
  "youp!ne": 1,
  youp1n: 1,
  "youp1n15@t1on": 1,
  youp1n15at1on: 1,
  "youp1n1s@t1on": 1,
  youp1n1sat1on: 1,
  youp1n3: 1,
  youp1ne: 1,
  youpin: 1,
  youpin3: 1,
  youpine: 1,
  "youpini5@tion": 1,
  youpini5ation: 1,
  "youpinis@tion": 1,
  youpinisation: 1,
  youtr3: 1,
  youtre: 1,
  zgu3gu3: 1,
  zguegu3: 1,
  "zguègu3": 1,
  zguegue: 1,
  "zguègue": 1
};